import { render, staticRenderFns } from "./device-selector.component.vue?vue&type=template&id=570a868a&scoped=true"
import script from "./device-selector.component.vue?vue&type=script&lang=ts"
export * from "./device-selector.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570a868a",
  null
  
)

export default component.exports